"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionSelectionCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_components_1 = __importStar(require("styled-components"));
const types_1 = require("@src/types");
const get_product_pricing_1 = require("@src/shared/get-product-pricing");
const icons_1 = require("@ant-design/icons");
const dayjs_1 = __importDefault(require("dayjs"));
const polished_1 = require("polished");
const elements_1 = require("@src/components/elements");
const SubscriptionSelectionCard = ({ subscriptionPeriod, showPricesWithVat, selectedSubscriptionPeriod, setSelectedSubscriptionPeriod, }) => {
    const { totalPriceWithoutVat, discountRelative, productPriceWithoutVat, productPrice, totalPrice } = (0, get_product_pricing_1.getProductPricing)({
        productId: types_1.ProductId.companyPremium,
        productCount: subscriptionPeriod,
    });
    const theme = (0, styled_components_1.useTheme)();
    const costPerMonth = showPricesWithVat ? productPrice : productPriceWithoutVat;
    const total = showPricesWithVat ? totalPrice : totalPriceWithoutVat;
    const subscriptionUntil = (0, dayjs_1.default)().add(subscriptionPeriod, 'month').format('DD.MM.YYYY');
    const isSelected = selectedSubscriptionPeriod === subscriptionPeriod;
    return ((0, jsx_runtime_1.jsxs)(SubscriptionCard, { subscriptionPeriod: subscriptionPeriod, onClick: () => setSelectedSubscriptionPeriod(subscriptionPeriod), isSelected: isSelected, children: [(0, jsx_runtime_1.jsxs)(ContentWrapper, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex-col justify-center align-center", children: [(0, jsx_runtime_1.jsx)(IconWrapper, { isSelected: isSelected, children: (0, jsx_runtime_1.jsx)(elements_1.PremiumIcon, { width: 32, height: 32, color: theme.color.white }) }), (0, jsx_runtime_1.jsx)(SubscriptionPeriodTitle, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.month.pluralized", values: { count: subscriptionPeriod } }) })] }), (0, jsx_runtime_1.jsxs)(DateSection, { isSelected: isSelected, children: [(0, jsx_runtime_1.jsx)(icons_1.CalendarOutlined, {}), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.subscription.until", values: { subscriptionUntil } })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-row align-baseline", children: [(0, jsx_runtime_1.jsx)(CostPerMonth, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedNumber, { value: costPerMonth, style: "currency", currency: "EUR" }) }), (0, jsx_runtime_1.jsx)(GrayText, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.subscription.per_month" }) })] })] }), (0, jsx_runtime_1.jsxs)(CardFooter, { children: [discountRelative > 0 && ((0, jsx_runtime_1.jsxs)("div", { className: "flex-row align-center justify-center", children: [(0, jsx_runtime_1.jsx)(GrayText, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.subscription.your_discount" }) }), (0, jsx_runtime_1.jsxs)(Discount, { children: ["~", (0, jsx_runtime_1.jsx)(react_intl_1.FormattedNumber, { value: discountRelative, style: "unit", unit: "percent" })] })] })), (0, jsx_runtime_1.jsx)(GrayText, { children: (0, jsx_runtime_1.jsxs)("div", { className: "flex-row align-baseline justify-center", children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.subscription.total" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedNumber, { value: total, style: "currency", currency: "EUR" })] }) })] })] }));
};
exports.SubscriptionSelectionCard = SubscriptionSelectionCard;
const SubscriptionCard = styled_components_1.default.div `
	width: 250px;
	height: 250px;
	border-radius: ${({ theme }) => theme.borderRadius.large};
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 1rem 1rem 0.5rem;
	cursor: pointer;
	justify-content: space-between;
	transition: 0.15s;
	${({ theme, isSelected }) => isSelected
    ? (0, styled_components_1.css) `
					border: 3px solid ${(0, polished_1.darken)(0.15, theme.color.gold)};
			  `
    : (0, styled_components_1.css) `
					border: 3px solid ${theme.color.gray5};
			  `}
	${({ subscriptionPeriod, theme }) => {
    if (subscriptionPeriod === types_1.SubscriptionPeriods.OneMonthPeriod) {
        return (0, styled_components_1.css) `
				background: linear-gradient(150deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, 0.3) 90%),
					${(0, polished_1.darken)(0.1, theme.color.brand2)};
				:hover {
					background: linear-gradient(150deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, 0.3) 90%),
						${(0, polished_1.darken)(0.15, theme.color.brand2)};
				}
			`;
    }
    if (subscriptionPeriod === types_1.SubscriptionPeriods.SixMonthsPeriod) {
        return (0, styled_components_1.css) `
				background: linear-gradient(150deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, 0.3) 90%),
					${(0, polished_1.darken)(0.1, theme.color.brand1)};
				:hover {
					background: linear-gradient(150deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, 0.3) 90%),
						${(0, polished_1.darken)(0.15, theme.color.brand1)};
				}
			`;
    }
    if (subscriptionPeriod === types_1.SubscriptionPeriods.TwelveMonthsPeriod) {
        return (0, styled_components_1.css) `
				background: linear-gradient(150deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, 0.3) 90%),
					${theme.color.brandDarkBlue};
				:hover {
					background: linear-gradient(150deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, 0.3) 90%),
						${(0, polished_1.darken)(0.05, theme.color.brandDarkBlue)};
				}
			`;
    }
}}
`;
const Discount = styled_components_1.default.span `
	margin-left: 0.5rem;
	font-size: 1.75rem;
	font-weight: bold;
	color: ${({ theme }) => theme.color.success};
`;
const SubscriptionPeriodTitle = styled_components_1.default.h3 `
	font-weight: bold;
	font-size: 1.5rem;
	color: ${({ theme }) => theme.color.white};
`;
const IconWrapper = styled_components_1.default.div `
	${({ isSelected, theme }) => isSelected &&
    (0, styled_components_1.css) `
			svg {
				color: ${(0, polished_1.darken)(0.15, theme.color.gold)};
			}
		`}
`;
const DateSection = styled_components_1.default.div `
	display: flex;
	align-items: center;
	gap: 0.5rem;
	font-weight: bold;
	justify-content: center;
	color: ${({ theme }) => theme.color.white};
	${({ isSelected, theme }) => isSelected &&
    (0, styled_components_1.css) `
			color: ${(0, polished_1.darken)(0.15, theme.color.gold)};
		`}
`;
const CostPerMonth = styled_components_1.default.div `
	margin-right: 0.5rem;
	font-size: 1.5rem;
	color: ${({ theme }) => theme.color.white};
`;
const GrayText = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.gray4};
`;
const CardFooter = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	gap: 0.5rem;
`;
const ContentWrapper = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	width: 100%;
	align-items: center;
`;
